const initialState = {
    data: '',
  };
  
  const reducer = (state = initialState, action) => {
      console.log("reducer::::::",action)
    switch (action.type) {
      case 'SET_DATA_SUCCESS':
        return {
          ...state,
          data: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;